module.exports = __webpack_public_path__ + "img/download_icon_key@3x.679ee882.png";